import 'material-components-web/dist/material-components-web.min.css';
import 'material-design-icons/iconfont/material-icons.css';
import { ComposerBridge } from 'ark-common';

interface Clipbook {
  readonly main: any;
  readonly attachments: ReadonlyArray<string>;
}

export class BrowserComposerBridge implements ComposerBridge {
  private readonly clipbooks: Record<string, Clipbook> = {};
  private readonly storage: Record<string, Record<string, Blob>> = {};
  public existingClipbooks = async () => {
    return [];
  }

  public blobFromClipboard = async () => {
    return new Blob();
  }

  public loadClipbookMain = async (containerID: string) => {
    const { clipbooks } = this;
    const container = clipbooks[containerID];
    if (container) {
      return container.main;
    }
    throw Error('Not found.');
  }

  public loadClipbookAttachment = async (containerID: string, attachmentID: string) => {
    const { storage } = this;
    const container = storage[containerID];
    if (container) {
      const attachment = container[attachmentID];
      if (attachment) {
        return new Blob([attachment], { type: attachment.type });
      }
    }
    throw Error('Not found.');
  }

  public saveClipbookAttachment = async (containerID: string, attachmentID: string, blob: Blob) => {
    const { storage } = this;
    const container = storage[containerID] || (storage[containerID] = {});
    container[attachmentID] = new Blob([blob], { type: blob.type });
  }

  public saveClipbook = async (containerID: string,
                               main: any,
                               attachments: ReadonlyArray<string>) => {
    this.clipbooks[containerID] = { main, attachments };
  }
}
